import React, { useEffect, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
import Count from "../../components/user/admin/Count";
import AdminMemberTable from "../../components/user/admin/AdminMemberTable";
import { IMemberListData } from "../../exports/interfaces";
import { fetchMemberLists } from "../../api/MemberApi";
import { dynamicFailed } from "../../hooks/useToast";
import { useUserDataContext } from "../../context/UserDataContext";
import { openLogin } from "../../exports/exports";
import { checkUser } from "../../api/UserApi";
import { useEventContext } from "../../context/EventContext";
import { fetchEventData } from "../../api/EventApi";

const AdminMembers = () => {
  const { setLoading } = useLoader();
  const { eventData, setEventData } = useEventContext();
  const [listMemberData, setListMemberData] = useState<IMemberListData[]>([]);
  const [memberCount, setMemberCount] = useState<number>(0);
  const [countryCount, setCountryCount] = useState<number>(0);
  const { userData, setUserData } = useUserDataContext();

  const accessToken = localStorage.getItem("frcsit:access-token");
  useEffect(() => {
    if (!userData) {
      if (accessToken === null || accessToken === undefined) {
        openLogin();
        return;
      }
      Promise.all([checkUser(accessToken)])
        .then(([userData]) => {
          setUserData(userData);
          userData?.data?.roles[0]?.name !== "sa" && openLogin();
        })
        .catch(() => {
          dynamicFailed("Server Error");
        });
    }
  }, [accessToken, setUserData, userData]);

  useEffect(() => {
    setLoading(true);
    if (eventData.length === 0) {
      Promise.all([fetchEventData()])
        .then(([eventData]) => {
          setEventData(eventData);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        })
        .catch(() => {
          dynamicFailed("Server Error");
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        });
    }
  }, [eventData.length, setEventData, setLoading]);

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchMemberLists()])
      .then(([listMemberData]) => {
        const pendingMembers = listMemberData.filter(
          (member: IMemberListData) => member.attributes?.Status === "Pending"
        );

        const nonPendingMembers = listMemberData.filter(
          (member: IMemberListData) => member.attributes?.Status !== "Pending"
        );

        const reorderedList = [...pendingMembers, ...nonPendingMembers];

        setListMemberData(reorderedList);
        const activeMembers = listMemberData.filter(
          (member: IMemberListData) => member.attributes?.Status === "Activate"
        );
        setMemberCount(activeMembers.length);
        const countries = activeMembers.map((member: IMemberListData) =>
          member.attributes?.Country?.trim()
        );
        const uniqueCountries = new Set(countries.filter(Boolean));
        setCountryCount(uniqueCountries.size);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [listMemberData.length, setLoading]);
  return (
    <>
      <Count
        Title={"Members"}
        memberCount={memberCount}
        countryCount={countryCount}
      />
      <AdminMemberTable listMemberData={listMemberData} />
    </>
  );
};

export default AdminMembers;
